import { Seo, Breadcrumbs, breadcrumbSchema, faqSchema } from "@/components/Seo";
import { Reveal, SectionTag } from "@/components/Motion";
import CoopNote from "@/components/CoopNote";
import { ChatButton, FinalCta, LearnMoreLink } from "@/components/Cta";
import { SERVICES } from "@/data/site";

const CRUMBS = [{ name: "首页", path: "/" }, { name: "我们的服务", path: "/services" }];

export default function Services() {
  return (
    <>
      <Seo
        title="TikTok Shop 服务 马来西亚 | 开店、代运营、商品优化 | TKShopMY"
        description="TKShopMY 为马来西亚卖家提供 TikTok Shop 服务：开店咨询、店铺代运营、商品上架优化、内容方向、活动规划及卖家一对一咨询，也提供一件代发及无需自行囤货合作模式咨询。"
        path="/services"
        schemas={[
          breadcrumbSchema(CRUMBS),
          {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "TKShopMY 服务列表",
            itemListElement: SERVICES.map((s, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: s.name,
              url: `https://tkshopmy.com${s.href}`,
            })),
          },
        ]}
      />
      <section className="pt-28 md:pt-40 pb-16 md:pb-20" data-testid="services-hero">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <Breadcrumbs items={CRUMBS} />
          <Reveal>
            <SectionTag>我们的服务</SectionTag>
            <h1 className="max-w-3xl font-display text-4xl font-medium leading-[1.15] text-balance sm:text-5xl lg:text-6xl">
              为马来西亚商家准备的 TikTok Shop 服务
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/65 md:text-lg">
              从第一次开店到长期店铺管理，以下每项服务都由每天和 TikTok Shop 卖家合作的
              马来西亚本地团队提供。不确定需要哪一项？直接 WhatsApp 问 —— 我们会坦白告诉你。
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="mx-auto max-w-6xl space-y-4 px-5 md:px-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={Math.min(i * 0.05, 0.3)}>
              <div
                id={s.id === "consultation" ? "seller-consultation" : s.id}
                className="group grid gap-6 rounded-2xl border border-ink/10 bg-white p-7 transition-all duration-300 hover:border-forest/30 hover:shadow-[0_16px_40px_rgba(16,23,17,0.08)] md:grid-cols-[80px_1fr_auto] md:items-center md:p-9"
                data-testid={`services-row-${s.id}`}
              >
                <span className="font-display text-4xl font-light italic text-moss/60">{s.num}</span>
                <div>
                  <h2 className="font-display text-2xl font-semibold text-ink">{s.name}</h2>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-ink/60">{s.short}</p>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:flex-col md:items-end">
                  <LearnMoreLink to={s.href}>了解更多</LearnMoreLink>
                  <ChatButton location={`services-${s.id}`} variant="sm" testId={`services-chat-${s.id}`}>
                    WhatsApp 咨询
                  </ChatButton>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-10 md:py-12 text-center">
        <div className="mx-auto max-w-3xl px-5 md:px-8">
          <CoopNote
            variant="short"
            title="一件代发 · 无需自行囤货"
            body="除了开店、商品、内容和运营支持，TKShopMY 也提供可了解的一件代发及无需自行囤货合作模式。"
            cta="了解合作方式"
            location="services-coop"
            testId="services-coop-note"
          />
        </div>
      </section>

      <FinalCta />
    </>
  );
}
